// extracted by mini-css-extract-plugin
export var content = "Content-module--content--ec9e5";